export enum SupplyTableColumn {
  AlreadyPurchasedQty = "already purchased qty",
  ETA = "eta",
  ETD = "etd",
  OPD = "opd",
  ForecastInPeriod = "forecast in period",
  // Values are persisted view-configuration ids: the labels became "Risk stock" but the strings
  // must not change, or every saved view loses these columns.
  RiskStockQty = "gambling qty",
  RiskStockPct = "risk buy pct",
  RecommendedRiskBuyPct = "recommended risk buy pct",
  ProjectedStockStartOfPeriod = "projected stock start of period",
  IncomingInPeriod = "incoming in period",
  SuggestedOrderInPeriod = "suggested order in period",
  TotalPurchaseQty = "total purchase qty",
  // The single planned-buy column: the sum of the per-warehouse editable columns (SLIM-581).
  PlannedBuyTotal = "planned buy total",
  // SUP-50: planned buy total less the live suggested order.
  SuggestedOrderDelta = "suggested order delta",
  // Read-only sum of every warehouse's demand — pre-orders for no-gambling warehouses, the
  // forecast elsewhere (HAK-2288).
  TotalDemand = "total demand",
  ProjectedStockEndOfPeriod = "projected stock end of period",
  // carhartt only: ingested per-SKU net availability incl. next season (the simulated-availability base).
  AvailableIncludingNextSeason = "available including next season",
  SimulatedAvailability = "simulated availability supply",
  // carhartt only: flags SKUs whose simulated availability is below zero after the planned buy.
  AvailabilityViolation = "availability violation",
  Comments = "comments",

  // SKU-level FashionBuyTable columns. Values reuse existing colId strings (PO/Product/
  // Collection) so users' saved column choices keep matching across old and new tables.
  Grouping = "grouping",
  // Hidden second-level row grouping (variant) used when grouping by a non-variant dimension.
  VariantGrouping = "variant-grouping",
  Sku = "skuId",
  Size = "size",
  SupplierSku = "supplierSku",
  Tags = "tags",
  PreOrders = "collection pre-orders",
  IncomingOrdersInPeriod = "collection purchase orders",
}

export enum NoosOrderSuggestionsColumn {
  OrderStatus = "orderStatus",
  SuggestedQty = "suggestedQty",
  MoqSuggestedQty = "moqSuggestedQty",
  OrderByDate = "orderByDate",
  TriggerReasons = "triggerReasons",
  TriggerStockout = "triggerStockout",
  TriggerImpact = "triggerImpact",
}
